import {Action, AlertProps, BreadcrumbType} from 'platform/components';

import {ReactNode} from 'react';

export type SettingsTemplateHeader = {
  title?: string;
  /** Drawn after the title, on the same line: for example a status flag. */
  titleAddon?: ReactNode;
  subtitle?: string;
  breadcrumbs?: BreadcrumbType[];
  actions?: Action[];
  alerts?: AlertProps[];
};
